import React from 'react';
import './NetworkStatus.css';
import {
  type StatusClass,
  StatusIconAssetLocation,
  StatusText,
} from './network-status-types.js';

type NetworkStatusIndicatorProps = {
  open: boolean;
  statusClass: StatusClass;
  classes?: string;
};

export function NetworkStatusIndicator(parameters: NetworkStatusIndicatorProps): React.ReactElement {
  const {open, statusClass, classes} = parameters;

  const getKeyFromStatus = (status: StatusClass, keysFrom: 'icons' | 'text'): string | undefined => {
    let collection: Array<[string, string]> = [];

    switch (keysFrom) {
      case 'icons': {
        collection = Object.entries(StatusIconAssetLocation);
        break;
      }

      case 'text': {
        collection = Object.entries(StatusText);
        break;
      }
    }

    if (collection !== null && open) {
      const value = collection.find(([key]) => key.toLowerCase() === status.toLowerCase())?.[1];
      return value === null ? undefined : value;
    }

    return undefined;
  };

  return (
    <div className={`${classes ?? ''} network-status ${open ? 'expanded' : ''} ${statusClass}'`.trim()}>
      <div className={`status-container ${statusClass} ${open ? '' : 'hidden'}`}>
        {open && (
          <span className='expanded-info'>
            <img className='status-icon' src={getKeyFromStatus(statusClass, 'icons') ?? StatusIconAssetLocation.NONE} />
            <span className='status-text'>{getKeyFromStatus(statusClass, 'text')}</span>
          </span>
        )}
        <div className={`network-status-indicator ${statusClass}`}>
          <div className={`indicator-inner ${statusClass}`}></div>
        </div>
      </div>
    </div>
  );
}
